import { asArray, elementOrArray } from '@proc7ts/primitives';
/**
 * Appends HTTP header value to server response.
 *
 * Avoids value duplication.
 *
 * @param response - HTTP response to add header to.
 * @param name - Target HTTP header name.
 * @param value - HTTP header value to add.
 */
export function addResponseHeader(response, name, value) {
    const oldValues = asArray(response.getHeader(name)).map(String);
    const newValues = elementOrArray(new Set(oldValues).add(value));
    response.setHeader(name, newValues);
}
//# sourceMappingURL=add-response-header.js.map